<template>
  <el-card>
    <el-alert
      v-if="ownerError"
      :title="ownerError"
      type="error"
      :closable="false"
    />
    <el-form inline size="small" @submit.native.prevent="search">
      <el-form-item label="货主">
        <el-select
          v-model="filters.customerId"
          filterable
          clearable
          remote
          :remote-method="q => searchOwners(q, filters.customerId)"
          :loading="customerLoading"
          :disabled="!ownerReady || !!boundCustomerId"
        >
          <el-option
            v-for="c in customers"
            :key="c.customerId"
            :value="c.customerId"
            :label="c.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="kind === 'accountBook'" label="账册号"
        ><el-input v-model="filters.accountBookNo" clearable
      /></el-form-item>
      <el-form-item label="料号"
        ><el-input v-model="filters.itemNo" clearable
      /></el-form-item>
      <el-form-item v-if="kind === 'expiry'" label="批次"
        ><el-input v-model="filters.batchId" clearable
      /></el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="!ownerReady" @click="search">
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <el-table :key="kind" v-loading="loading" :data="rows" border>
      <el-table-column
        v-for="column in columns"
        :key="column[0]"
        :prop="column[0]"
        :label="column[1]"
        :width="column[2]"
        :min-width="column[2] ? undefined : 150"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="column[0] === 'qualityType'"
            data-test="quality-type"
            :type="qualityTagType(scope.row.qualityType)"
            >{{ qualityTypeName(scope.row.qualityType) }}</el-tag
          >
          <span v-else>{{ scope.row[column[0]] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="kind === 'accountBook' ? '占用数量（申报冻结）' : '占用数量'"
        :width="kind === 'expiry' ? 80 : undefined"
        :min-width="kind === 'accountBook' ? 180 : undefined"
      >
        <template slot-scope="scope">
          <el-button
            v-if="occupied(scope.row) > 0"
            type="text"
            data-test="occupancy"
            :aria-label="'查看占用记录 ' + occupied(scope.row)"
            @click="showRecords(scope.row, 'occupancy')"
            >{{ occupied(scope.row) }}</el-button
          >
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="kind === 'expiry'"
        prop="lockedQty"
        label="锁定数量"
        width="110"
      />
      <el-table-column label="操作" fixed="right" width="120"
        ><template slot-scope="scope">
          <el-button
            type="text"
            data-test="ledger"
            @click="showRecords(scope.row, 'ledger')"
            >查看流水</el-button
          >
        </template></el-table-column
      >
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-size="10"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="changePage"
    />
    <stock-records-dialog
      v-if="selected"
      :key="dialogKey"
      :kind="kind"
      :stock="selected"
      :record-type="recordType"
      @close="selected = null"
    />
  </el-card>
</template>

<script>
import api from "@/api/warehouseReceipt";
import owner from "./owner";
import StockRecordsDialog from "./StockRecordsDialog";

export default {
  components: { StockRecordsDialog },
  mixins: [owner],
  props: { kind: { type: String, required: true } },
  data() {
    return {
      filters: { customerId: "", accountBookNo: "", itemNo: "", batchId: "" },
      rows: [],
      pageIndex: 1,
      total: 0,
      loading: false,
      error: "",
      selected: null,
      recordType: "",
      dialogKey: 0,
      requestId: 0
    };
  },
  computed: {
    columns() {
      return [["customerId", "货主"]].concat(
        this.kind === "accountBook"
          ? [
              ["accountBookNo", "账册号"],
              ["itemNo", "商品料号"]
            ]
          : [
              ["itemNo", "商品料号"],
              ["batchId", "WMS批次"],
              ["inboundOrderId", "来源入库单"],
              ["productionDate", "生产日期", 100],
              ["expireDate", "失效日期", 100],
              ["inboundDate", "入库日期", 100],
              ["qualityType", "质量类型"]
            ],
        [
          ["totalQty", "总量", 80],
          ["availableQty", "可用数量", 80]
        ]
      );
    }
  },
  created() {
    this.reload();
  },
  watch: {
    kind() {
      this.rows = [];
      this.selected = null;
      this.filters = {
        customerId: this.boundCustomerId,
        accountBookNo: "",
        itemNo: "",
        batchId: ""
      };
      this.search();
    }
  },
  beforeDestroy() {
    this.requestId++;
  },
  methods: {
    async reload() {
      if (await this.initOwner()) {
        this.filters.customerId = this.boundCustomerId;
        this.search();
      }
    },
    occupied(row) {
      if (this.kind === "accountBook") return row.frozenQty;
      return row.occupiedQty == null
        ? row.totalQty - row.availableQty - row.lockedQty
        : row.occupiedQty;
    },
    qualityTypeName(value) {
      return { N: "正品", Y: "残次品" }[value] || value;
    },
    qualityTagType(value) {
      return { N: "success", Y: "danger" }[value] || "info";
    },
    showRecords(row, type) {
      this.selected = { ...row };
      this.recordType = type;
      this.dialogKey++;
    },
    search() {
      this.pageIndex = 1;
      this.fetch();
    },
    changePage(page) {
      this.pageIndex = page;
      this.fetch();
    },
    async fetch() {
      if (!this.ownerReady) return;
      const id = ++this.requestId;
      this.loading = true;
      this.error = "";
      this.rows = [];
      const request = {
        customerId: this.boundCustomerId || this.filters.customerId,
        itemNo: this.filters.itemNo,
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      if (this.kind === "accountBook")
        request.accountBookNo = this.filters.accountBookNo;
      else request.batchId = this.filters.batchId;
      try {
        const res = await api[this.kind].stock(request);
        if (id !== this.requestId) return;
        this.rows = res.items || [];
        this.total = res.page.totalCount;
      } catch (error) {
        if (id === this.requestId) this.error = "库存加载失败，请重试";
      } finally {
        if (id === this.requestId) this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.el-pagination {
  margin-top: 16px;
}
</style>
